import { Component, OnInit } from '@angular/core';
import { CdkDragDrop, moveItemInArray } from '@angular/cdk/drag-drop';
import { ActivatedRoute, Router } from '@angular/router';
import { SmartintegService } from '../../../../services/smartinteg.service';
import { ToastService } from '../../../../services/toast.service';
import { RecursoCriacaoService } from '../../../../services/recurso-criacao.service';
import { mensagemErroApi } from '../../../../utils/mensagem-erro-api';
import { ProblemaPipeline, validarPipeline } from '../../../../components/smartinteg/pipeline-validacao/pipeline.util';
import { infoLogin, loginCompleto, ordenarEndpointsParaLogin, rotuloEndpointLogin } from '../../../../components/smartinteg/autenticacao-config/autenticacao.util';
import { IteracaoForm, camposParaMapa, mapaParaCampos, novoComandoFilho, novoIteracaoForm, validarIteracao } from '../../../../components/smartinteg/iteracao-config/iteracao.util';
import { lerFiltros, montarFiltros, novosFiltrosForm, validarFiltros } from '../../../../components/smartinteg/mapeamento-filtros/mapeamento-filtros.util';
import { camposDisponiveis, descreverRetorno, placeholder, placeholdersDesconhecidos, validarExportacao } from '../../../../components/smartinteg/exportacao-config/exportacao.util';
import { lerFormatacao, montarFormatacao, novoFormatacaoForm, validarFormatacao } from '../../../../components/smartinteg/formatacao-config/formatacao-config.util';
import { lerAgrupamento, montarAgrupamento, novoAgrupamentoForm, validarAgrupamento } from '../../../../components/smartinteg/agrupamento-config/agrupamento-config.util';
import { lerJoinConfig, montarJoinConfig, novoJoinForm, validarJoin } from '../../../../components/smartinteg/join-config/join-config.util';
import { 
  Processo, 
  Recurso, 
  TipoRecurso, 
  TipoComando, 
  PublicacaoConfig, 
  DirecaoPublicacao, 
  FonteDadosPublicacao,
  DestinoRecebimento,
  ModoProcessamento,
  FormatoResposta,
  Comando,
  ComandoMapeamento,
  CriarComandoRequest,
  CriarRecursoRequest,
  AgrupamentoConfigForm,
  Dataset,
  FiltrosMapeamentoForm,
  FormatacaoConfigForm,
  JoinConfigForm,
  ProvedorConexao,
  ProvedorEndpoint
} from '../../../../types/smartinteg';
import { ConfirmationService } from 'primeng/api';
import { switchMap, of, forkJoin, map, catchError, Observable, from, concatMap, toArray } from 'rxjs';

@Component({
  selector: 'app-processo-fluxo',
  templateUrl: './processo-fluxo.component.html',
  styleUrls: ['./processo-fluxo.component.css'],
  providers: [ConfirmationService]
})
export class ProcessoFluxoComponent implements OnInit {

  processoId!: string;
  processo: Processo | null = null;
  recursos: Recurso[] = [];
  loading: boolean = true;
  
  // Seleção e Detalhes
  recursoSelecionado: any = null;
  comandoDetalhe: any = null;
  mapeamentoDetalhe: any = null;
  mostrarCamposMapeamento = true;
  abaProcessamento: 'geral' | 'campos' | 'conversoes' | 'descarte' = 'geral';
  abaEtapa = 'geral';
  get ehProcessamento(): boolean {
    return this.recursoSelecionado?.tipoRecurso === TipoRecurso.PROCESSAMENTO;
  }
  get abasDaEtapa(): { id: string; rotulo: string; quantidade?: number }[] {
    const geral = { id: 'geral', rotulo: 'Geral' };
    switch (this.recursoSelecionado?.tipoRecurso) {
      case TipoRecurso.IMPORTACAO: return [geral, { id: 'comando', rotulo: 'Origem dos dados' }];
      case TipoRecurso.AUTENTICACAO: return [geral, { id: 'comando', rotulo: 'Login' }];
      case TipoRecurso.ITERACAO: return [geral, { id: 'comando', rotulo: 'Listagem' }, { id: 'campos', rotulo: 'Campos por item', quantidade: this.iteracaoForm?.campos.length }, { id: 'filho', rotulo: 'Recurso por item' }];
      case TipoRecurso.VISUALIZACAO: return [geral, { id: 'campos', rotulo: 'Campos', quantidade: this.quantidadeCamposMapeamento }, ...(this.publicacaoConfig ? [{ id: 'publicacao', rotulo: 'Publicação' }] : [])];
      case TipoRecurso.EXPORTACAO: return [geral, { id: 'fonte', rotulo: 'Fonte e retorno' }, { id: 'comando', rotulo: 'Destino' }];
      case TipoRecurso.PUBLICACAO: return [geral,
        ...(['OUTBOUND', 'BIDIRECIONAL'].includes(this.publicacaoConfig?.direcao) ? [{ id: 'saida', rotulo: 'Saída' }] : []),
        ...(['INBOUND', 'BIDIRECIONAL'].includes(this.publicacaoConfig?.direcao) ? [{ id: 'entrada', rotulo: 'Entrada' }] : [])];
      case TipoRecurso.DATASET: return [geral, { id: 'comando', rotulo: 'Origem dos dados' }];
      case TipoRecurso.JOIN: return [geral, { id: 'dataset', rotulo: 'Dataset' }, { id: 'chave', rotulo: 'Chave' }, { id: 'filtros', rotulo: 'Filtros' }, { id: 'campos', rotulo: 'Campos' }];
      case TipoRecurso.AGRUPAMENTO: return [geral, { id: 'chaves', rotulo: 'Agrupar por' }, { id: 'ordenacao', rotulo: 'Ordenação' }, { id: 'tratamentos', rotulo: 'Tratamentos', quantidade: this.agrupamentoForm?.tratamentos.length }, { id: 'opcoes', rotulo: 'Opções' }];
      case TipoRecurso.FORMATACAO: return [geral, { id: 'regras', rotulo: 'Regras', quantidade: this.formatacaoForm?.regras.length }];
      default: return [];
    }
  }
  get abaGeralVisivel(): boolean {
    return this.ehProcessamento ? this.abaProcessamento === 'geral' : this.abaEtapa === 'geral';
  }
  trackAba(_index: number, aba: { id: string }): string { return aba.id; }
  get quantidadeCamposMapeamento(): number {
    return Object.keys(this.mapeamentoDetalhe?.mapeamentos ?? {}).length;
  }
  // Filtros do mapeamento (de-para + descarte): só o PROCESSAMENTO os usa; VISUALIZACAO os ignora no runtime
  filtrosMapeamentoForm: FiltrosMapeamentoForm | null = null;
  publicacaoConfig: any = null;
  loadingDetalhes: boolean = false;
  isNew: boolean = false;
  private versaoSelecao = 0;
  
  // Opções apresentadas no seletor de etapas, na ordem em que costumam aparecer no fluxo.
  mostrarSeletorEtapas = false;
  readonly tiposEtapa: { tipo: TipoRecurso; titulo: string }[] = [
    { tipo: TipoRecurso.IMPORTACAO, titulo: 'Importação' },
    { tipo: TipoRecurso.AUTENTICACAO, titulo: 'Autenticação' },
    { tipo: TipoRecurso.ITERACAO, titulo: 'Iteração' },
    { tipo: TipoRecurso.PROCESSAMENTO, titulo: 'Processamento' },
    { tipo: TipoRecurso.VISUALIZACAO, titulo: 'Visualização' },
    { tipo: TipoRecurso.EXPORTACAO, titulo: 'Exportação' },
    { tipo: TipoRecurso.PUBLICACAO, titulo: 'Publicação' },
    { tipo: TipoRecurso.DATASET, titulo: 'Dataset' },
    { tipo: TipoRecurso.AGRUPAMENTO, titulo: 'Agrupamento' },
    { tipo: TipoRecurso.FORMATACAO, titulo: 'Formatação' },
    { tipo: TipoRecurso.JOIN, titulo: 'Cruzamento de dados (Join)' }
  ];
  opcoesDirecao = [
    { label: 'Envio (Outbound)', value: DirecaoPublicacao.OUTBOUND },
    { label: 'Recebimento (Inbound)', value: DirecaoPublicacao.INBOUND },
    { label: 'Bidirecional', value: DirecaoPublicacao.BIDIRECIONAL }
  ];
  opcoesFonteDados = [
    { label: 'Registros Brutos', value: FonteDadosPublicacao.REGISTROS_BRUTOS },
    { label: 'Registros Transformados', value: FonteDadosPublicacao.REGISTROS_TRANSFORMADOS },
    { label: 'Registros de Visualização', value: FonteDadosPublicacao.REGISTROS_VISUALIZACAO }
  ];
  opcoesDestinoRecebimento = [
    { label: 'Banco de Dados', value: DestinoRecebimento.BANCO_DADOS },
    { label: 'API Externa', value: DestinoRecebimento.API_EXTERNA },
    { label: 'Fila de Processamento', value: DestinoRecebimento.FILA_PROCESSAMENTO }
  ];
  opcoesModoProcessamento = [
    { label: 'Síncrono', value: ModoProcessamento.SINCRONO },
    { label: 'Assíncrono', value: ModoProcessamento.ASSINCRONO }
  ];
  opcoesFormatoResposta = [
    { label: 'JSON', value: FormatoResposta.JSON }
  ];
  opcoesTipoComando = [
    { label: 'SQL (Banco de Dados)', value: TipoComando.DATABASE_SQL },
    { label: 'Endpoint (API REST)', value: TipoComando.API_ENDPOINT }
  ];

  // Listas de apoio para seleção em Inbound e Comandos
  todosComandos: Comando[] = [];
  todosMapeamentos: ComandoMapeamento[] = [];
  todasConexoes: ProvedorConexao[] = [];
  todosEndpoints: ProvedorEndpoint[] = [];
  todosDatasets: Dataset[] = [];
  private datasetsCarregados = false;
  // Todos os endpoints do tenant: alimentam a validação de tokens do pipeline e a reabertura de comandos de API
  todosEndpointsGlobais: ProvedorEndpoint[] = [];
  // Configurações de publicação: a exportação guarda nelas a fonte (mapeamento) dos registros
  todasConfigsPublicacao: PublicacaoConfig[] | null = null;
  validacoesPipeline: ProblemaPipeline[] = [];
  joinForm: JoinConfigForm | null = null;
  agrupamentoForm: AgrupamentoConfigForm | null = null;
  iteracaoForm: IteracaoForm | null = null;
  // Recursos do fluxo principal: os filhos de uma ITERACAO só rodam dentro do loop e aparecem no painel do pai
  recursosVisiveis: Recurso[] = [];
  formatacaoForm: FormatacaoConfigForm | null = null;

  constructor(
    private route: ActivatedRoute,
    private router: Router,
    private smartintegService: SmartintegService,
    private toastService: ToastService,
    private recursoCriacaoService: RecursoCriacaoService,
    private confirmationService: ConfirmationService
  ) {}

  selecionarTipoEtapa(tipo: TipoRecurso): void {
    this.mostrarSeletorEtapas = false;
    this.iniciarCriacaoRecurso(tipo);
  }

  ngOnInit(): void {
    this.processoId = this.route.snapshot.paramMap.get('processoId')!;
    if (this.processoId) {
      this.carregarProcesso();
      this.carregarRecursos();
      this.carregarAuxiliares();
    } else {
      this.toastService.erro('Erro', 'ID do processo não encontrado.');
      this.voltar();
    }
  }

  carregarAuxiliares(): void {
    const falha = (o_que: string) => (err: any) =>
      this.toastService.alerta('Atenção', `Não foi possível carregar ${o_que}: ${mensagemErroApi(err, 'erro inesperado')}`);
    this.smartintegService.listarComandos().subscribe({ next: data => { this.todosComandos = data; this.atualizarValidacoes(); }, error: falha('a lista de comandos') });
    this.smartintegService.listarPublicacoes().subscribe({ next: data => { this.todasConfigsPublicacao = data; this.atualizarValidacoes(); }, error: falha('a lista de configurações de publicação') });
    this.smartintegService.listarEndpoints().subscribe({ next: data => { this.todosEndpointsGlobais = data; this.atualizarValidacoes(); }, error: falha('a lista de endpoints') });
    this.smartintegService.listarMapeamentos().subscribe({ next: data => this.todosMapeamentos = data, error: falha('a lista de mapeamentos') });
    this.smartintegService.listarDatasets().subscribe({ next: data => { this.todosDatasets = data; this.datasetsCarregados = true; this.atualizarValidacoes(); }, error: falha('a lista de datasets') });
    this.smartintegService.listarProvedores().pipe(
      switchMap(provedores => {
        const conexoesObs = provedores.map(p => this.smartintegService.listarConexoesPorProvedor(p.id));
        return conexoesObs.length > 0 ? forkJoin(conexoesObs) : of([]);
      })
    ).subscribe(res => {
      this.todasConexoes = res.flat();
    });
  }

  onConexaoChange(conexaoId: string): void {
    if (conexaoId) {
      this.smartintegService.listarEndpointsPorConexao(conexaoId).subscribe(data => {
        // endpoints legados sem identificador não podem ser vinculados a um comando
        this.todosEndpoints = data.filter(e => !!e.id);
      });
    } else {
      this.todosEndpoints = [];
    }
  }

  carregarProcesso(): void {
    this.smartintegService.buscarProcesso(this.processoId).subscribe({
      next: (data) => this.processo = data
    });
  }

  carregarRecursos(): void {
    this.loading = true;
    this.smartintegService.listarRecursosPorProcesso(this.processoId).subscribe({
      next: (data) => {
        this.recursos = data.sort((a, b) => a.ordemExecucao - b.ordemExecucao);
        this.recursosVisiveis = this.recursos.filter(r => !r.recursoPaiId);
        this.atualizarValidacoes();
        this.loading = false;
      },
      error: (err) => {
        this.toastService.erro('Erro', 'Falha ao carregar recursos do processo.');
        this.loading = false;
      }
    });
  }

  selecionarRecurso(recurso: Recurso): void {
    const versao = ++this.versaoSelecao;
    this.abaProcessamento = 'geral';
    this.abaEtapa = 'geral';
    this.mostrarCamposMapeamento = false;
    this.recursoSelecionado = { ...recurso };
    if (recurso.tipoRecurso === TipoRecurso.DATASET) {
      const cfg = recurso.configuracoes ?? {};
      this.recursoSelecionado.configuracoes = { ...cfg, datasetId: cfg['datasetId'] ?? null, camposChave: [...(cfg['camposChave'] ?? [])] };
    }
    this.isNew = false;
    this.joinForm = recurso.tipoRecurso === TipoRecurso.JOIN ? lerJoinConfig(recurso.configuracoes?.['join']) : null;
    this.agrupamentoForm = recurso.tipoRecurso === TipoRecurso.AGRUPAMENTO ? lerAgrupamento(recurso.configuracoes?.['agrupamento']) : null;
    this.formatacaoForm = recurso.tipoRecurso === TipoRecurso.FORMATACAO ? lerFormatacao(recurso.configuracoes?.['formatacoes']) : null;
    this.iteracaoForm = recurso.tipoRecurso === TipoRecurso.ITERACAO ? this.lerIteracao(recurso) : null;
    this.comandoDetalhe = null;
    this.mapeamentoDetalhe = null;
    this.filtrosMapeamentoForm = null;
    this.publicacaoConfig = null;
    this.loadingDetalhes = true;

    const observables = [];

    // 1. Carregar Configuração de Publicação (Publicação ou Visualização)
    if (recurso.tipoRecurso === TipoRecurso.PUBLICACAO || recurso.tipoRecurso === TipoRecurso.VISUALIZACAO || recurso.temPublicacaoConfig) {
      observables.push(
        this.smartintegService.buscarPublicacaoPorRecurso(recurso.id).pipe(
          map(config => ({ type: 'publicacao', data: config ? { ...config } : this.initPublicacaoConfig(recurso.id) })),
          catchError(() => of({ type: 'publicacao', data: this.initPublicacaoConfig(recurso.id) }))
        )
      );
    }

    // 2. Carregar Comando (Importação, Exportação ou Genérico)
    if (recurso.tipoRecurso === TipoRecurso.IMPORTACAO || recurso.tipoRecurso === TipoRecurso.EXPORTACAO || recurso.temComando) {
      observables.push(
        this.smartintegService.listarComandosPorRecurso(recurso.id).pipe(
          map(comandos => ({ type: 'comando', data: comandos.length > 0 ? { ...comandos[0] } : this.initComando(recurso.id) })),
          catchError(() => of({ type: 'comando', data: null }))
        )
      );
    }

    // 3. Carregar Mapeamento (Processamento, Visualização ou Genérico)
    // AGRUPAMENTO/FORMATACAO/JOIN apenas apontam para o mapeamento do PROCESSAMENTO: não o editam aqui
    const apontaParaMapeamentoAlheio = [TipoRecurso.AGRUPAMENTO, TipoRecurso.FORMATACAO, TipoRecurso.JOIN].includes(recurso.tipoRecurso);
    if (recurso.tipoRecurso === TipoRecurso.PROCESSAMENTO || recurso.tipoRecurso === TipoRecurso.VISUALIZACAO || (recurso.temComandoMapeamento && !apontaParaMapeamentoAlheio)) {
      observables.push(
        this.smartintegService.listarMapeamentosPorRecurso(recurso.id).pipe(
          switchMap(mapeamentos => {
            if (mapeamentos.length > 0) return of(mapeamentos[0]);
            // Dado legado: o vínculo existe só no sentido recurso -> mapeamento (Recurso.comandoMapeamentoId);
            // o mapeamento ficou com recursoId nulo e "GET .../recurso/{id}" não o encontra. Busca pelo id direto.
            return recurso.comandoMapeamentoId
              ? this.smartintegService.buscarMapeamento(recurso.comandoMapeamentoId).pipe(catchError(() => of(null)))
              : of(null);
          }),
          map(m => ({ type: 'mapeamento', data: m ? { ...m } : this.initMapeamento(recurso.id) })),
          catchError(() => of({ type: 'mapeamento', data: null }))
        )
      );
    }

    if (observables.length > 0) {
      forkJoin(observables).subscribe({
        next: (results: any[]) => {
          if (versao !== this.versaoSelecao) return;
          results.forEach(res => {
            if (res.type === 'publicacao' && res.data) {
              this.publicacaoConfig = res.data;
              // Tratamento de nulls do backend
              if (this.publicacaoConfig.ativo === null || this.publicacaoConfig.ativo === undefined) {
                this.publicacaoConfig.ativo = true;
              }
              if (!this.publicacaoConfig.operadoresFiltro) this.publicacaoConfig.operadoresFiltro = {};
              if (!this.publicacaoConfig.filtrosFixos) this.publicacaoConfig.filtrosFixos = {};
              if (!this.publicacaoConfig.transformacoesSaida) this.publicacaoConfig.transformacoesSaida = {};
              if (!this.publicacaoConfig.camposRetorno) this.publicacaoConfig.camposRetorno = [];
              if (!this.publicacaoConfig.camposFiltro) this.publicacaoConfig.camposFiltro = [];
            }
            if (res.type === 'comando' && res.data) {
              this.comandoDetalhe = res.data;
              // comando de API só guarda o endpoint: descobre a conexão dele para listar os endpoints no dropdown
              if (!this.comandoDetalhe.conexaoId && this.comandoDetalhe.endpointId) {
                this.comandoDetalhe.conexaoId = this.todosEndpointsGlobais.find(e => e.id === this.comandoDetalhe.endpointId)?.conexaoId;
              }
              if (this.comandoDetalhe.conexaoId) {
                this.onConexaoChange(this.comandoDetalhe.conexaoId);
              }
            }
            if (res.type === 'mapeamento' && res.data) {
              this.mapeamentoDetalhe = res.data;
              if (recurso.tipoRecurso === TipoRecurso.PROCESSAMENTO) this.filtrosMapeamentoForm = lerFiltros(this.mapeamentoDetalhe.filtros);
            }
          });
          this.loadingDetalhes = false;
        },
        error: (err) => {
          if (versao !== this.versaoSelecao) return;
          console.error('Erro ao carregar detalhes do recurso', err);
          this.loadingDetalhes = false;
          this.toastService.erro('Erro', 'Falha ao carregar detalhes do recurso.');
        }
      });
    } else {
      this.loadingDetalhes = false;
    }
  }

  iniciarCriacaoRecurso(tipo: TipoRecurso): void {
    ++this.versaoSelecao;
    this.abaProcessamento = 'geral';
    this.abaEtapa = 'geral';
    this.mostrarCamposMapeamento = true;
    this.isNew = true;
    this.recursoSelecionado = {
      processoId: this.processoId,
      tipoRecurso: tipo,
      nome: `Novo Recurso - ${tipo}`,
      descricao: '',
      ordemExecucao: this.recursos.length + 1,
      ativo: true,
      codigo: ''
    };
    if (tipo === TipoRecurso.DATASET) {
      this.recursoSelecionado.configuracoes = { datasetId: null, camposChave: [] };
    }
    this.joinForm = null;
    this.agrupamentoForm = null;
    this.formatacaoForm = null;
    this.iteracaoForm = null;
    if (tipo === TipoRecurso.JOIN || tipo === TipoRecurso.AGRUPAMENTO || tipo === TipoRecurso.FORMATACAO) {
      if (tipo === TipoRecurso.JOIN) this.joinForm = novoJoinForm();
      else if (tipo === TipoRecurso.AGRUPAMENTO) this.agrupamentoForm = novoAgrupamentoForm();
      else this.formatacaoForm = novoFormatacaoForm();
      // lê os RegistroTransformado do mapeamento do PROCESSAMENTO: sugere o do último processamento do fluxo
      const opcoes = this.mapeamentosProcessamento;
      this.recursoSelecionado.comandoMapeamentoId = opcoes.length > 0 ? opcoes[opcoes.length - 1].value : null;
    }
    
    this.comandoDetalhe = null;
    this.mapeamentoDetalhe = null;
    this.publicacaoConfig = null;
    this.loadingDetalhes = false;

    if (tipo === TipoRecurso.IMPORTACAO || tipo === TipoRecurso.EXPORTACAO || tipo === TipoRecurso.DATASET || tipo === TipoRecurso.AUTENTICACAO || tipo === TipoRecurso.ITERACAO) {
      this.comandoDetalhe = this.initComando(0);
      if (tipo === TipoRecurso.ITERACAO) {
        // a listagem vem sempre de API; o filho é criado junto (ver iteracaoForm)
        this.comandoDetalhe.tipo = TipoComando.API_ENDPOINT;
        this.comandoDetalhe.nome = 'Listagem de itens';
        this.iteracaoForm = novoIteracaoForm();
      }
      if (tipo === TipoRecurso.EXPORTACAO) {
        // a fonte é o mapeamento do último processamento do fluxo; o destino é o comando (SQL ou API) do próprio recurso
        this.publicacaoConfig = { ...this.initPublicacaoConfig(0), nome: 'Exportação', retornoIntegracao: false, retornarIntegracao: false };
        const opcoes = this.mapeamentosProcessamento;
        this.publicacaoConfig.mapeamentoRecebimentoId = opcoes.length > 0 ? opcoes[opcoes.length - 1].value : null;
      }
      if (tipo === TipoRecurso.AUTENTICACAO) {
        // o login é sempre uma chamada de API: o corpo vai em "comando" e os cabeçalhos em "parametros"
        this.comandoDetalhe.tipo = TipoComando.API_ENDPOINT;
        this.comandoDetalhe.nome = 'Login';
      }
    } else if (tipo === TipoRecurso.PROCESSAMENTO || tipo === TipoRecurso.VISUALIZACAO) {
      this.mapeamentoDetalhe = this.initMapeamento(0);
      if (tipo === TipoRecurso.PROCESSAMENTO) this.filtrosMapeamentoForm = novosFiltrosForm();
      // if (tipo === TipoRecurso.VISUALIZACAO) {
      //   this.publicacaoConfig = this.initPublicacaoConfig(0);
      // }
    } else if (tipo === TipoRecurso.PUBLICACAO) {
      this.publicacaoConfig = this.initPublicacaoConfig(0);
    }
  }

  initComando(recursoId: number): any {
    return {
      recursoId: recursoId,
      nome: 'Comando Padrão',
      descricao: '',
      tipo: TipoComando.DATABASE_SQL,
      comando: '',
      ativo: true,
      camposChave: [],
      parametros: {}
    };
  }

  initMapeamento(recursoId: number): any {
    return {
      recursoId: recursoId,
      nome: 'Mapeamento Padrão',
      descricao: '',
      mapeamentos: {},
      filtros: {},
      ativo: true
    };
  }

  initPublicacaoConfig(recursoId: number): any {
    return {
      recursoId: recursoId,
      nome: 'Configuração de Publicação',
      descricao: '',
      direcao: DirecaoPublicacao.OUTBOUND,
      fonteDados: FonteDadosPublicacao.REGISTROS_TRANSFORMADOS,
      camposRetorno: [],
      suportaPaginacao: true,
      limitePadrao: 50,
      limiteMaximo: 500,
      ordenacaoPadrao: '',
      camposFiltro: [],
      operadoresFiltro: {},
      filtrosFixos: {},
      transformacoesSaida: {},
      destinoDados: DestinoRecebimento.BANCO_DADOS,
      mapeamentoRecebimentoId: null,
      comandoDestinoId: null,
      schemaEntrada: null,
      camposObrigatorios: [],
      validarSchema: true,
      permitirCamposExtras: false,
      modoProcessamento: ModoProcessamento.SINCRONO,
      formatoResposta: FormatoResposta.JSON,
      ativo: true
    };
  }

  salvarRecurso(): void {
    if (!this.recursoSelecionado?.nome?.trim()) {
      this.abaProcessamento = 'geral';
      this.abaEtapa = 'geral';
      this.toastService.alerta('Nome obrigatório', 'Dê um nome à etapa antes de salvar.');
      return;
    }
    this.recursoSelecionado.nome = this.recursoSelecionado.nome.trim();
    this.normalizarChavesDataset();
    const problemaConfig = this.prepararConfiguracaoDoPipeline() ?? (!this.isNew && this.ehIteracao ? this.prepararIteracao() : null);
    if (problemaConfig) {
      this.abrirAbaDoProblema(problemaConfig);
      this.toastService.alerta('Atenção', problemaConfig);
      return;
    }
    this.loadingDetalhes = true;

    if (this.isNew) {
      this.salvarNovoRecurso();
    } else {
      this.atualizarRecursoExistente();
    }
  }

  // ---------- Recurso EXPORTACAO ----------

  get ehExportacao(): boolean {
    return this.recursoSelecionado?.tipoRecurso === TipoRecurso.EXPORTACAO;
  }

  // Fonte: mapeamentos dos processamentos do fluxo; mantém o valor atual mesmo que venha de um dado antigo
  get opcoesMapeamentoOrigem(): { label: string; value: number }[] {
    const opcoes = this.mapeamentosProcessamento;
    const atual = this.publicacaoConfig?.mapeamentoRecebimentoId;
    if (atual && !opcoes.some(o => o.value === atual)) {
      const m = this.todosMapeamentos.find(x => x.id === atual);
      return [{ label: `${m?.nome ?? 'Mapeamento'} (#${atual})`, value: atual }, ...opcoes];
    }
    return opcoes;
  }

  // Campos que o registro exportado terá: destinos do mapeamento + o que JOINs e agrupamentos anteriores acrescentam
  get camposDaExportacao() {
    const id: number | null = this.publicacaoConfig?.mapeamentoRecebimentoId ?? null;
    const anteriores = this.recursos.filter(r => r.ordemExecucao < (this.recursoSelecionado?.ordemExecucao ?? Infinity));
    return camposDisponiveis(this.todosMapeamentos.find(m => m.id === id)?.mapeamentos, id, anteriores);
  }

  get placeholdersDesconhecidosDoComando(): string[] {
    return placeholdersDesconhecidos(this.comandoDetalhe?.comando, this.camposDaExportacao, this.comandoDetalhe?.parametros);
  }

  get descricaoRetorno(): string {
    return descreverRetorno(!!this.publicacaoConfig?.retornoIntegracao, !!this.publicacaoConfig?.retornarIntegracao);
  }

  // Texto com ${} montado no código: o template não pode ter essa sequência literal
  readonly dicaTemplateExportacao = 'Escreva o comando de destino com ' + placeholder('campo') + ' onde cada registro deve entrar; ele roda uma vez por registro.';

  placeholderDe(campo: string): string { return placeholder(campo); }

  // A lista é recalculada a cada verificação (getter): sem trackBy os botões seriam recriados entre o mouse baixar e soltar e o clique se perderia
  trackCampo(_indice: number, campo: { campo: string }): string { return campo.campo; }

  inserirPlaceholder(campo: string): void {
    this.comandoDetalhe.comando = (this.comandoDetalhe.comando ?? '') + placeholder(campo);
  }

  // ---------- Recurso ITERACAO ----------

  get ehIteracao(): boolean {
    return this.recursoSelecionado?.tipoRecurso === TipoRecurso.ITERACAO;
  }

  // AUTENTICACAO e ITERACAO usam sempre um comando de API
  get comandoSoApi(): boolean {
    return this.ehAutenticacao || this.ehIteracao;
  }

  get conexoesDeApi(): ProvedorConexao[] {
    return this.todasConexoes;
  }

  // Reabre a iteração: campos, recurso por item (comandoLoop é o id do RECURSO filho) e o comando dele
  private lerIteracao(recurso: Recurso): IteracaoForm {
    const cfg = recurso.configuracoes?.['iteracao'] ?? {};
    const filho = this.recursos.find(r => r.id === cfg['comandoLoop']) ?? this.recursos.find(r => r.recursoPaiId === recurso.id);
    const form = novoIteracaoForm();
    form.campos = mapaParaCampos(cfg['campos']);
    if (filho) {
      form.filho = { id: filho.id, nome: filho.nome, descricao: filho.descricao ?? '' };
      this.smartintegService.listarComandosPorRecurso(filho.id).subscribe({
        next: cmds => { if (cmds.length > 0 && this.iteracaoForm === form) form.comandoFilho = { ...novoComandoFilho(), ...cmds[0] }; },
        error: () => this.toastService.alerta('Atenção', 'Não foi possível carregar o comando do recurso por item.')
      });
    }
    return form;
  }

  // Valida a parte da iteração e grava o comandoLoop e os campos em configuracoes.iteracao; devolve o problema, se houver
  private prepararIteracao(): string | null {
    const f = this.iteracaoForm;
    if (!f) return 'Configuração da iteração não carregada.';
    const problema = validarIteracao(f);
    if (problema) return problema;
    if (!this.isNew) {
      if (!f.filho.id) return 'Esta iteração não tem um recurso por item vinculado (dado antigo). Exclua e recrie a iteração.';
      this.recursoSelecionado.configuracoes = {
        ...(this.recursoSelecionado.configuracoes ?? {}),
        iteracao: { comandoLoop: f.filho.id, campos: camposParaMapa(f.campos) }
      };
    }
    return null;
  }

  // Requisição de comando a partir do formulário (SQL usa a conexão; API usa o endpoint)
  private comandoRequest(c: any, importacao: boolean): CriarComandoRequest {
    const sql = c.tipo === TipoComando.DATABASE_SQL;
    return {
      nome: c.nome.trim(),
      descricao: c.descricao || undefined,
      tipo: c.tipo,
      conexaoId: sql ? c.conexaoId : undefined,
      endpointId: sql ? undefined : c.endpointId,
      comando: (c.comando ?? '').trim() ? c.comando : undefined, // SQL, ou corpo da requisição de API
      parametros: c.parametros,
      camposChave: importacao && (c.camposChave ?? []).length > 0 ? c.camposChave : undefined,
      camposIgnorarComparacao: importacao ? c.camposIgnorarComparacao : undefined
    };
  }

  // ---------- Recurso AUTENTICACAO ----------

  get ehAutenticacao(): boolean {
    return this.recursoSelecionado?.tipoRecurso === TipoRecurso.AUTENTICACAO;
  }

  // Endpoints da conexão escolhida; no login, os que já geram token aparecem primeiro e destacados
  get opcoesEndpointLogin(): { label: string; value: string }[] {
    return ordenarEndpointsParaLogin(this.todosEndpoints).map(e => ({ label: rotuloEndpointLogin(e), value: e.id }));
  }

  get endpointDoComando(): ProvedorEndpoint | undefined {
    const id = this.comandoDetalhe?.endpointId;
    return id ? (this.todosEndpoints.find(e => e.id === id) ?? this.todosEndpointsGlobais.find(e => e.id === id)) : undefined;
  }

  get infoLoginDoComando() { return infoLogin(this.endpointDoComando); }
  get loginDoComandoCompleto(): boolean { return loginCompleto(this.endpointDoComando); }

  get rotaEndpointsDaConexao(): string[] | null {
    const e = this.endpointDoComando;
    return e ? ['/smartinteg/provedores', e.provedorId, 'conexoes', e.conexaoId, 'endpoints'] : null;
  }

  // Quem consome um token que nenhum login anterior gera falha na execução (NPE no backend)
  atualizarValidacoes(): void {
    this.validacoesPipeline = validarPipeline({
      recursos: this.recursos,
      comandos: this.todosComandos,
      endpoints: this.todosEndpointsGlobais,
      // listas ainda não carregadas não geram acusações (dataset "inexistente" ou fonte "de outro fluxo" falsos)
      datasetIds: this.datasetsCarregados ? this.todosDatasets.map(d => d.id) : null,
      configsPublicacao: this.todasConfigsPublicacao
    });
  }

  get totalErrosPipeline(): number { return this.validacoesPipeline.filter(p => p.nivel === 'erro').length; }
  get totalAvisosPipeline(): number { return this.validacoesPipeline.filter(p => p.nivel === 'aviso').length; }

  // Abre o recurso do problema (um recurso por item abre a iteração a que pertence)
  abrirProblema(problema: ProblemaPipeline): void {
    const r = this.recursos.find(x => x.id === problema.recursoId);
    const alvo = r?.recursoPaiId ? this.recursos.find(x => x.id === r.recursoPaiId) : r;
    if (alvo) this.selecionarRecurso(alvo);
  }

  // ---------- Recurso DATASET ----------

  // A carga usa os campos chave do RECURSO (não os do Dataset): padroniza em maiúsculas, sem espaços nem repetição
  normalizarChavesDataset(): void {
    const cfg = this.recursoSelecionado?.configuracoes;
    if (this.recursoSelecionado?.tipoRecurso !== TipoRecurso.DATASET || !cfg) return;
    cfg.camposChave = [...new Set(((cfg.camposChave ?? []) as string[]).map(c => c.trim().toUpperCase()).filter(c => c.length > 0))];
  }

  get datasetDoRecurso(): Dataset | undefined {
    const id = this.recursoSelecionado?.configuracoes?.datasetId;
    return this.todosDatasets.find(d => d.id === id);
  }

  // Ao escolher o dataset, sugere os campos chave dele (o usuário pode ajustar)
  onDatasetChange(): void {
    const ds = this.datasetDoRecurso;
    if (ds && (this.recursoSelecionado.configuracoes.camposChave ?? []).length === 0) {
      this.recursoSelecionado.configuracoes.camposChave = [...ds.camposChave];
    }
  }

  // Chaves do recurso diferentes das do dataset: a carga usa as do recurso e os dados podem não casar com o esperado pelo JOIN
  get chavesDivergemDoDataset(): boolean {
    const ds = this.datasetDoRecurso;
    if (!ds) return false;
    const norm = (l: string[]) => [...new Set((l ?? []).map(c => c.trim().toUpperCase()).filter(c => c))].join('|');
    return norm(ds.camposChave) !== norm(this.recursoSelecionado.configuracoes.camposChave);
  }

  // ---------- Recurso JOIN ----------

  // AGRUPAMENTO/FORMATACAO/JOIN leem os registros do mapeamento do PROCESSAMENTO do mesmo processo
  get mapeamentosProcessamento(): { label: string; value: number }[] {
    return this.recursos
      .filter(r => r.tipoRecurso === TipoRecurso.PROCESSAMENTO && !!r.comandoMapeamentoId)
      .map(r => ({ label: `${r.nome} (ordem ${r.ordemExecucao})`, value: r.comandoMapeamentoId as number }));
  }

  // AGRUPAMENTO/FORMATACAO/JOIN apontam para o mapeamento do PROCESSAMENTO (sem ele não há registros para processar)
  private exigirMapeamentoOrigem(): string | null {
    return this.recursoSelecionado.comandoMapeamentoId
      ? null
      : 'Selecione o mapeamento de origem. Crie antes um recurso de Processamento neste fluxo, se ainda não houver.';
  }

  private abrirAbaDoProblema(problema: string): void {
    const tipo = this.recursoSelecionado?.tipoRecurso;
    if (tipo === TipoRecurso.PROCESSAMENTO) return;
    if (tipo === TipoRecurso.JOIN) {
      this.abaEtapa = /mapeamento de origem/i.test(problema) ? 'geral'
        : /campo a copiar|campo copiado|campo de destino/i.test(problema) ? 'campos'
        : /dataset/i.test(problema) && !/Filtro/i.test(problema) ? 'dataset'
        : /[Cc]have/.test(problema) ? 'chave'
        : /[Ff]iltro/.test(problema) ? 'filtros' : 'campos';
    } else if (tipo === TipoRecurso.AGRUPAMENTO) {
      this.abaEtapa = /mapeamento de origem/i.test(problema) ? 'geral'
        : /[Cc]have|campo de agrupamento/.test(problema) ? 'chaves'
        : /Ordenação/.test(problema) ? 'ordenacao' : 'tratamentos';
    } else if (tipo === TipoRecurso.FORMATACAO) {
      this.abaEtapa = /mapeamento de origem/i.test(problema) ? 'geral' : 'regras';
    } else if (tipo === TipoRecurso.ITERACAO) {
      this.abaEtapa = /listagem|variável|^Campo \d/i.test(problema) ? 'campos'
        : /recurso por item|recurso executado por item/i.test(problema) ? 'filho' : 'comando';
    } else if (tipo === TipoRecurso.EXPORTACAO) {
      this.abaEtapa = /mapeamento de origem/i.test(problema) ? 'fonte' : 'comando';
    } else if (tipo === TipoRecurso.DATASET) {
      this.abaEtapa = /dataset|campo chave/i.test(problema) ? 'geral' : 'comando';
    } else if (tipo === TipoRecurso.IMPORTACAO || tipo === TipoRecurso.AUTENTICACAO) {
      this.abaEtapa = 'comando';
    } else {
      this.abaEtapa = 'geral';
    }
  }

  // Valida o formulário do tipo e o grava em recursoSelecionado.configuracoes (JOIN e AGRUPAMENTO); devolve o problema, se houver
  private prepararConfiguracaoDoPipeline(): string | null {
    const r = this.recursoSelecionado;
    if (r?.tipoRecurso === TipoRecurso.JOIN) {
      const problema = this.exigirMapeamentoOrigem() ?? (this.joinForm ? validarJoin(this.joinForm) : 'Configuração do JOIN não carregada.');
      if (problema) return problema;
      r.configuracoes = { ...(r.configuracoes ?? {}), join: montarJoinConfig(this.joinForm!) };
    } else if (r?.tipoRecurso === TipoRecurso.AGRUPAMENTO) {
      const problema = this.exigirMapeamentoOrigem() ?? (this.agrupamentoForm ? validarAgrupamento(this.agrupamentoForm) : 'Configuração do agrupamento não carregada.');
      if (problema) return problema;
      r.configuracoes = { ...(r.configuracoes ?? {}), agrupamento: montarAgrupamento(this.agrupamentoForm!) };
    } else if (r?.tipoRecurso === TipoRecurso.EXPORTACAO) {
      // sem configuração de publicação (dado antigo) só o comando pode ser editado
      if (this.isNew || this.publicacaoConfig) {
        const problema = validarExportacao(this.publicacaoConfig) ?? this.validarComando();
        if (problema) return problema;
      }
    } else if (r?.tipoRecurso === TipoRecurso.FORMATACAO) {
      const problema = this.exigirMapeamentoOrigem() ?? (this.formatacaoForm ? validarFormatacao(this.formatacaoForm) : 'Configuração da formatação não carregada.');
      if (problema) return problema;
      // aninhamento duplo: configuracoes.formatacoes.formatacoes
      r.configuracoes = { ...(r.configuracoes ?? {}), formatacoes: montarFormatacao(this.formatacaoForm!) };
    } else if (r?.tipoRecurso === TipoRecurso.PROCESSAMENTO && this.filtrosMapeamentoForm) {
      const problema = validarFiltros(this.filtrosMapeamentoForm);
      if (problema) {
        this.abaProcessamento = problema.startsWith('De-Para') ? 'conversoes' : 'descarte';
        return problema;
      }
      this.mapeamentoDetalhe.filtros = montarFiltros(this.filtrosMapeamentoForm);
    }
    return null;
  }

  // Nome e detalhes obrigatórios por tipo; devolve a mensagem do primeiro problema ou null
  private validarNovoRecurso(): string | null {
    const r = this.recursoSelecionado;
    if (!r.nome?.trim()) return 'Informe o nome do recurso.';
    switch (r.tipoRecurso) {
      case TipoRecurso.DATASET:
        if (!r.configuracoes?.datasetId) return 'Selecione o dataset que receberá a carga.';
        if ((r.configuracoes.camposChave ?? []).length === 0) return 'Informe ao menos um campo chave da carga.';
        return this.validarComando();
      case TipoRecurso.ITERACAO:
        return this.validarComando() ?? this.prepararIteracao();
      case TipoRecurso.AUTENTICACAO:
      case TipoRecurso.IMPORTACAO:
        return this.validarComando();
      case TipoRecurso.JOIN:
      case TipoRecurso.AGRUPAMENTO:
      case TipoRecurso.FORMATACAO:
      case TipoRecurso.EXPORTACAO:
        return null; // validados em prepararConfiguracaoDoPipeline
      case TipoRecurso.PROCESSAMENTO:
      case TipoRecurso.VISUALIZACAO:
        if (this.mapeamentoDetalhe.nome?.trim()) return null;
        if (r.tipoRecurso === TipoRecurso.PROCESSAMENTO) this.abaProcessamento = 'geral';
        return 'Informe o nome do mapeamento.';
      case TipoRecurso.PUBLICACAO:
        if (!r.codigo?.trim()) return 'Informe o código (slug da URL) da publicação.';
        if (/[\s/]/.test(r.codigo.trim())) return 'O código da publicação não pode ter espaços nem "/".';
        return this.publicacaoConfig.nome?.trim() ? null : 'Informe o nome da configuração de publicação.';
      default:
        return `A criação de recursos do tipo ${r.tipoRecurso} ainda não está disponível nesta tela.`;
    }
  }

  private validarComando(): string | null {
    const c = this.comandoDetalhe;
    if (this.comandoSoApi) c.tipo = TipoComando.API_ENDPOINT;
    if (!c.nome?.trim()) return 'Informe o nome do comando.';
    if (c.tipo === TipoComando.DATABASE_SQL) {
      if (!c.conexaoId) return 'Selecione a conexão do comando.';
      if (!c.comando?.trim()) return 'Informe o SQL do comando.';
    } else if (!c.endpointId) {
      return 'Selecione o endpoint do comando.';
    }
    return null;
  }

  // Criação sempre pelo RecursoCriacaoService: POST /recursos + detalhe, desfazendo tudo se algum passo falhar
  salvarNovoRecurso(): void {
    const problema = this.validarNovoRecurso();
    if (problema) {
      this.abrirAbaDoProblema(problema);
      this.toastService.alerta('Atenção', problema);
      this.loadingDetalhes = false;
      return;
    }

    const r = this.recursoSelecionado;
    const recurso: CriarRecursoRequest = {
      processoId: this.processoId,
      tipoRecurso: r.tipoRecurso,
      nome: r.nome.trim(),
      descricao: r.descricao || undefined,
      ordemExecucao: r.ordemExecucao,
      codigo: r.codigo?.trim() || undefined
    };

    let obs$: Observable<unknown>;
    switch (r.tipoRecurso) {
      case TipoRecurso.DATASET:
      case TipoRecurso.AUTENTICACAO:
      case TipoRecurso.IMPORTACAO: {
        const c = this.comandoDetalhe;
        const dataset = r.tipoRecurso === TipoRecurso.DATASET;
        const importacao = r.tipoRecurso === TipoRecurso.IMPORTACAO;
        if (dataset) recurso.configuracoes = { datasetId: r.configuracoes.datasetId, camposChave: r.configuracoes.camposChave };
        obs$ = this.recursoCriacaoService.criarComComando(recurso, this.comandoRequest(c, importacao));
        break;
      }
      case TipoRecurso.EXPORTACAO: {
        const c = this.publicacaoConfig;
        obs$ = this.recursoCriacaoService.criarExportacao(recurso, this.comandoRequest(this.comandoDetalhe, false), {
          nome: `Exportação: ${r.nome.trim()}`,
          direcao: DirecaoPublicacao.OUTBOUND,
          fonteDados: FonteDadosPublicacao.REGISTROS_TRANSFORMADOS,
          formatoResposta: FormatoResposta.JSON,
          mapeamentoRecebimentoId: c.mapeamentoRecebimentoId,
          retornoIntegracao: !!c.retornoIntegracao,
          retornarIntegracao: !!c.retornarIntegracao,
          ativo: true
        });
        break;
      }
      case TipoRecurso.ITERACAO: {
        const f = this.iteracaoForm!;
        // pai, filho (recursoPaiId) e por fim o PUT do pai com configuracoes.iteracao: o comandoLoop é o id do filho
        obs$ = this.recursoCriacaoService.criarIteracao(
          recurso,
          this.comandoRequest(this.comandoDetalhe, false),
          { processoId: this.processoId, tipoRecurso: TipoRecurso.IMPORTACAO, nome: f.filho.nome.trim(), descricao: f.filho.descricao || undefined, ordemExecucao: 1 },
          this.comandoRequest(f.comandoFilho, true),
          camposParaMapa(f.campos)
        );
        break;
      }
      case TipoRecurso.PROCESSAMENTO:
      case TipoRecurso.VISUALIZACAO: {
        const m = this.mapeamentoDetalhe;
        obs$ = this.recursoCriacaoService.criarComMapeamento(recurso, {
          nome: m.nome.trim(),
          descricao: m.descricao || undefined,
          comandoOrigemId: m.comandoOrigemId || undefined,
          mapeamentos: m.mapeamentos ?? {},
          filtros: m.filtros
        });
        break;
      }
      case TipoRecurso.AGRUPAMENTO:
      case TipoRecurso.FORMATACAO:
      case TipoRecurso.JOIN:
        obs$ = this.recursoCriacaoService.criarSimples({
          ...recurso,
          comandoMapeamentoId: r.comandoMapeamentoId,
          configuracoes: r.configuracoes
        });
        break;
      default: { // PUBLICACAO (validarNovoRecurso já barrou os demais)
        const c = this.publicacaoConfig;
        obs$ = this.recursoCriacaoService.criarComPublicacao(recurso, {
          nome: c.nome.trim(),
          descricao: c.descricao || undefined,
          direcao: c.direcao,
          fonteDados: c.fonteDados,
          camposRetorno: c.camposRetorno,
          suportaPaginacao: c.suportaPaginacao,
          limitePadrao: c.limitePadrao,
          limiteMaximo: c.limiteMaximo,
          ordenacaoPadrao: c.ordenacaoPadrao,
          camposFiltro: c.camposFiltro,
          operadoresFiltro: c.operadoresFiltro,
          filtrosFixos: c.filtrosFixos,
          transformacoesSaida: c.transformacoesSaida,
          destinoDados: c.destinoDados,
          mapeamentoRecebimentoId: c.mapeamentoRecebimentoId,
          comandoDestinoId: c.comandoDestinoId,
          schemaEntrada: c.schemaEntrada,
          camposObrigatorios: c.camposObrigatorios,
          validarSchema: c.validarSchema,
          permitirCamposExtras: c.permitirCamposExtras,
          modoProcessamento: c.modoProcessamento,
          respostaSucesso: c.respostaSucesso,
          respostaErro: c.respostaErro,
          formatoResposta: c.formatoResposta,
          ativo: true
        });
      }
    }

    obs$.subscribe({
      next: () => {
        this.toastService.sucesso('Sucesso', 'Recurso criado com sucesso.');
        this.loadingDetalhes = false;
        this.recursoSelecionado = null;
        this.joinForm = null;
        this.agrupamentoForm = null;
        this.formatacaoForm = null;
        this.iteracaoForm = null;
        this.isNew = false;
        this.carregarRecursos();
        // Comandos e mapeamentos recém-criados precisam aparecer nas listas de seleção (origem, destino)
        this.carregarAuxiliares();
      },
      error: (err: any) => {
        // ErroCriacaoRecurso já traz a mensagem do backend e o aviso de itens que não puderam ser desfeitos
        this.toastService.erro('Erro', 'Falha ao criar recurso: ' + mensagemErroApi(err, err?.message ?? 'erro inesperado'));
        this.loadingDetalhes = false;
      }
    });
  }

  atualizarRecursoExistente(): void {
    const updateRecurso$ = this.smartintegService.atualizarRecurso(this.recursoSelecionado);
    
    let updateDetalhe$: any = of(null);
    
    if (this.comandoDetalhe && this.comandoDetalhe.id) {
      updateDetalhe$ = this.smartintegService.atualizarComando(this.comandoDetalhe);
    } else if (this.mapeamentoDetalhe && this.mapeamentoDetalhe.id) {
      updateDetalhe$ = this.smartintegService.atualizarMapeamento(this.mapeamentoDetalhe);
    } else if (this.publicacaoConfig && this.publicacaoConfig.id) {
      updateDetalhe$ = this.smartintegService.atualizarPublicacao(this.publicacaoConfig);
    }

    const atualizacoes: Observable<unknown>[] = [updateRecurso$, updateDetalhe$];
    // EXPORTACAO tem comando de destino E configuração de publicação: os dois são gravados (a cadeia acima só pega o primeiro)
    if (this.ehExportacao && this.publicacaoConfig?.id) {
      atualizacoes.push(this.smartintegService.atualizarPublicacao(this.publicacaoConfig));
    }
    const f = this.iteracaoForm;
    if (this.ehIteracao && f?.filho.id) {
      const filhoAtual = this.recursos.find(r => r.id === f.filho.id);
      // PUT de recurso substitui os campos antigos: reenvia ordem e código; recursoPaiId e configuracoes ausentes são mantidos
      atualizacoes.push(this.smartintegService.atualizarRecurso({
        id: f.filho.id, tipoRecurso: filhoAtual?.tipoRecurso ?? TipoRecurso.IMPORTACAO, nome: f.filho.nome.trim(),
        descricao: f.filho.descricao || undefined, ordemExecucao: filhoAtual?.ordemExecucao ?? 1, codigo: filhoAtual?.codigo ?? undefined
      }));
      if (f.comandoFilho?.id) atualizacoes.push(this.smartintegService.atualizarComando(f.comandoFilho));
    }

    forkJoin(atualizacoes).subscribe({
      next: () => {
        this.toastService.sucesso('Sucesso', 'Recurso atualizado.');
        this.loadingDetalhes = false;
        this.recursoSelecionado = null;
        this.carregarRecursos();
      },
      error: (err: any) => {
        this.toastService.erro('Erro', 'Falha ao atualizar recurso.');
        console.error(err);
        this.loadingDetalhes = false;
      }
    });
  }

  cancelarEdicao(): void {
    ++this.versaoSelecao;
    this.recursoSelecionado = null;
    this.joinForm = null;
    this.agrupamentoForm = null;
    this.formatacaoForm = null;
    this.iteracaoForm = null;
    this.isNew = false;
  }

  // Reordenação em lote: todos os ids do nível na nova ordem, numa transação (evita ordens repetidas)
  onReorder(event: CdkDragDrop<Recurso[]>): void {
    if (event.previousIndex === event.currentIndex) return;
    moveItemInArray(this.recursosVisiveis, event.previousIndex, event.currentIndex);
    this.loading = true;
    const ids = this.recursosVisiveis.map(r => r.id);
    this.smartintegService.reordenarRecursosEmLote(this.processoId, ids).subscribe({
      next: () => {
        this.toastService.sucesso('Sucesso', 'Ordem atualizada.');
        this.carregarRecursos();
      },
      error: (err) => {
        this.toastService.erro('Erro', 'Falha ao salvar nova ordem: ' + mensagemErroApi(err));
        this.carregarRecursos();
      }
    });
  }

  excluirRecurso(recurso: Recurso): void {
    // Os recursos por item de uma ITERACAO só existem dentro dela: saem junto, antes do pai
    const filhos = this.recursos.filter(r => r.recursoPaiId === recurso.id);
    const aviso = filhos.length > 0 ? ` Os ${filhos.length} recurso(s) executado(s) por item também serão removidos.` : '';
    this.confirmationService.confirm({
      message: `Tem certeza que deseja remover o recurso "${recurso.nome}"?${aviso}`,
      header: 'Confirmar Exclusão',
      icon: 'pi pi-exclamation-triangle',
      acceptLabel: 'Sim',
      rejectLabel: 'Não',
      accept: () => {
        const remocoes$ = from([...filhos, recurso]).pipe(
          concatMap(r => this.smartintegService.deletarRecurso(r.id)),
          toArray()
        );
        remocoes$.subscribe({
          next: () => {
            this.toastService.sucesso('Sucesso', 'Recurso removido.');
            this.carregarRecursos();
            if (this.recursoSelecionado?.id === recurso.id) {
              this.recursoSelecionado = null;
              this.iteracaoForm = null;
            }
          },
          error: (err) => {
            this.toastService.erro('Erro', 'Falha ao remover recurso: ' + mensagemErroApi(err));
            this.carregarRecursos();
          }
        });
      }
    });
  }

  // Explica em uma frase o que o recurso faz no fluxo, para quem não conhece o modelo técnico
  descricaoTipoRecurso(tipo: TipoRecurso): string {
    switch (tipo) {
      case TipoRecurso.IMPORTACAO: return 'Busca dados de uma fonte externa (banco de dados ou API) e grava como registros brutos do processo.';
      case TipoRecurso.AUTENTICACAO: return 'Faz login numa API externa e guarda o token para os recursos seguintes usarem.';
      case TipoRecurso.ITERACAO: return 'Busca uma lista e repete outro recurso uma vez para cada item dela (ex.: buscar o detalhe de cada item).';
      case TipoRecurso.PROCESSAMENTO: return 'Transforma os registros brutos em registros de negócio: renomeia campos (de-para) e pode descartar registros indesejados.';
      case TipoRecurso.VISUALIZACAO: return 'Prepara uma versão simplificada dos registros, só para consulta (não usa os filtros do Processamento).';
      case TipoRecurso.EXPORTACAO: return 'Envia os registros transformados para um destino externo (banco de dados ou API), um por um.';
      case TipoRecurso.PUBLICACAO: return 'Expõe os registros do processo como uma API própria, com uma URL pública.';
      case TipoRecurso.DATASET: return 'Carrega uma lista de referência (ex.: uma tabela de calendário) para outros recursos consultarem.';
      case TipoRecurso.AGRUPAMENTO: return 'Agrupa vários registros em um só por uma chave (ex.: somar os valores do mesmo dia).';
      case TipoRecurso.FORMATACAO: return 'Ajusta o formato de datas e números dos registros (ex.: casas decimais, formato de data).';
      case TipoRecurso.JOIN: return 'Busca dados complementares em um Dataset e acrescenta aos registros (ex.: adicionar o nome do período).';
      default: return '';
    }
  }

  rotuloTipoRecurso(tipo: TipoRecurso): string {
    const rotulos: Partial<Record<TipoRecurso, string>> = {
      [TipoRecurso.IMPORTACAO]: 'Importação',
      [TipoRecurso.AUTENTICACAO]: 'Autenticação',
      [TipoRecurso.ITERACAO]: 'Iteração',
      [TipoRecurso.PROCESSAMENTO]: 'Processamento',
      [TipoRecurso.VISUALIZACAO]: 'Visualização',
      [TipoRecurso.EXPORTACAO]: 'Exportação',
      [TipoRecurso.PUBLICACAO]: 'Publicação',
      [TipoRecurso.DATASET]: 'Dataset',
      [TipoRecurso.AGRUPAMENTO]: 'Agrupamento',
      [TipoRecurso.FORMATACAO]: 'Formatação',
      [TipoRecurso.JOIN]: 'Cruzamento de dados'
    };
    return rotulos[tipo] ?? tipo;
  }

  getIconeRecurso(tipo: TipoRecurso): string {
    switch (tipo) {
      case TipoRecurso.IMPORTACAO: return 'pi pi-cloud-download';
      case TipoRecurso.PROCESSAMENTO: return 'pi pi-cog';
      case TipoRecurso.VISUALIZACAO: return 'pi pi-eye';
      case TipoRecurso.EXPORTACAO: return 'pi pi-cloud-upload';
      case TipoRecurso.PUBLICACAO: return 'pi pi-globe';
      case TipoRecurso.AUTENTICACAO: return 'pi pi-key';
      case TipoRecurso.ITERACAO: return 'pi pi-sync';
      case TipoRecurso.AGRUPAMENTO: return 'pi pi-chart-bar';
      case TipoRecurso.FORMATACAO: return 'pi pi-calculator';
      case TipoRecurso.DATASET: return 'pi pi-database';
      case TipoRecurso.JOIN: return 'pi pi-link';
      default: return 'pi pi-question';
    }
  }
  
  irParaWizard(): void {
    this.router.navigate(['/smartinteg/processos', this.processoId, 'wizard']);
  }

  executarProcesso(): void {
    this.router.navigate(['/smartinteg/processos', this.processoId, 'executar']);
  }

  voltar(): void {
    this.router.navigate(['/smartinteg/processos']);
  }
}
